import { ActionStatisticsDashboardActionType } from "../manufacturer/actionDashboard/types";

export type TreatableProps = {
  patient_name: string;
  patient_id: number;
  bi_case_id: number;
  reverification: string | boolean;
  bi_completed: string;
  insurance_type?: string;
  physician?: string;
  medical_coverage_status: string;
  medical_coverage_status_color: number;
  medical_coverage_status_title: string;
  medical_coverage_tooltip: string;
  medical_next_steps: string[];
  pharmacy_coverage_status: string;
  pharmacy_coverage_status_color: 1 | 2 | 3 | 4 | 5;
  pharmacy_coverage_status_title: string;
  pharmacy_coverage_tooltip: string;
  pharmacy_next_steps: (
    | string
    | {
        tooltip: string;
        sp: string;
        msg: string;
      }
  )[];

  pharmacy_provide_treatment_status?: string[];
  medical_provide_treatment_status?: string[];
  payer?: string;
  indication: string;
  confirm_indication: {
    text: "";
    clickable: false;
  };
  kam_fam_notes: {
    text: "";
    clickable: false;
    type: string;
  };
  scheduled_tx_date: "Schedule";
  case_type: string;
  patient_actv_status: string;
  prescription_id: number;
  next_steps: string[];
  // provider_patient_status_next_steps: [
  //   "Treatment Scheduled",
  //   "Treatment Schedule",
  //   "No Action Required",
  //   "Not Treating",
  //   "Schedule",
  //   "Treated",
  //   "Transferred",
  //   "Not Treated",
  //   "Precert",
  //   "Review",
  //   "Appeal",
  //   "Transferred to other Specialty Pharmacy",
  //   "Transfer to CenterWell",
  //   "Transfer to Knipper"
  // ];
  active_precert_id: number;
  pending_precert_id: number;
  appeal_precert_id: number;
  rx_pa_prior_auth_id: number;
  review_prior_auth_id: number;
  appeal_prior_auth_id: number;
  re_run_type:string;
  message_icon:boolean;
  pcc:string;
  qns:string
  pa_workflow_required:boolean;
  investigated_at?: string | null;
  practice_fax_number: number;
  practice_full_address: string;
  practice_name: string;
  practice_phone_number: number;
};
export type CoverageAvailableProps = {
  treatables_data: TreatableProps[];
  page_count: number;
  dpn_count: number;
};
export type TodoDataProps = {
  patient_name: string;
  patient_id: number;
  bi_case_id: number;
  reverification: string;
  bi_completed: string;
  investigated_at?: string | null;
  insurance_type?: string;
  physician: string;
  medical_coverage_status: string;
  medical_coverage_status_color: 1 | 2 | 3 | 4 | 5;
  medical_coverage_status_title: string;
  medical_coverage_tooltip: string;
  treatment_next_steps: null | string[];
  pharmacy_coverage_status: string;
  pharmacy_coverage_status_color: 1 | 2 | 3 | 4 | 5;
  pharmacy_coverage_status_title: string;
  pharmacy_coverage_tooltip: string;
  patient_next_steps: null | string[];
  payer?: string;
  medical_next_steps: string[];
  pharmacy_next_steps: string[];
  // next_steps: ["Treated", "Transferred", "Not Treated"];
  patient_actv_status: string;
  indication: string;
  confirm_indication: {
    text: "";
    clickable: false;
  };
  kam_fam_notes: {
    text: string;
    clickable: boolean;
    type: string;
  };
  scheduled_tx_date: "Schedule";
  case_type: string;
  prescription_id: number;
  next_steps: string[];
  active_precert_id: number;
  pending_precert_id: number;
  appeal_precert_id: number;
  rx_pa_prior_auth_id: number;
  review_prior_auth_id: number;
  appeal_prior_auth_id: number;
  re_run_type:string;
  message_icon:boolean;
  pcc:string;
  qns:string
  pa_workflow_required:boolean;
  practice_fax_number: number;
  practice_full_address: string;
  practice_name: string;
  practice_phone_number: number;
};
export type ActionRequiredProps = {
  todos_data: TodoDataProps[];
  page_count: number;
  dpn_count: number;
};
export type NotTreatedData = {
  patient_name: string;
  patient_id: number;
  bi_case_id: number;
  reverification: string | boolean;
  bi_submitted: string | null;
  bi_completed: string | null;
  investigated_at?: string | null;
  insurance_type: string | null;
  provider: string;
  medical_coverage_status: string;
  medical_coverage_status_color: 1 | 2 | 3 | 4 | 5;
  medical_coverage_status_title: string;
  medical_coverage_tooltip: string;
  not_treated_button: boolean;
  pharmacy_coverage_status: string;
  pharmacy_coverage_status_color: 1 | 2 | 3 | 4 | 5;
  pharmacy_coverage_status_title: string;
  pharmacy_coverage_tooltip: string;
  not_treated_pharmacy: boolean;
  pharmacy_provide_treatment_status?: string[];
  payer?: string;
  physician?: string;
  indication: string;
  confirm_indication: {
    text: "";
    clickable: false;
  };
  case_type?: string;
  kam_fam_notes?: {
    text: string;
    clickable: boolean;
    type: string;
  };
  prescription_id: number;

  next_steps: string[];
  active_precert_id: number;
  pending_precert_id: number;
  appeal_precert_id: number;
  rx_pa_prior_auth_id: number;
  review_prior_auth_id: number;
  appeal_prior_auth_id: number;
  re_run_type:string;
  message_icon:boolean;
  patient_actv_status: string;
  pcc:string;
  qns:string
  pa_workflow_required:boolean;
  practice_fax_number: number;
  practice_full_address: string;
  practice_name: string;
  practice_phone_number: number;
};
export type PendingDataProps = {
  not_treateds_data: NotTreatedData[];
  page_count: number;
  dpn_count: number;
};
export type sp_treatments_data = {
  next_steps: string[];
  patient_name: string;
  patient_id: number;
  bi_case_id: number;
  provider: string;
  investigated_at?: string | null;
  sp_transferred_to: string;
  sp_transfered_to: string;
  date_transferred: string;
  status_update: {
    status: string;
    color: string;
  };
  date_shipped: string;
  carrier: string;
  tracking_number: string;
  pharmacy_sp_status: string;
  pharmacy_sp_status_color: number;
  pharmacy_coverage_tooltip: string;
  provide_treatment_status: string[];
  indication: string;
  patient_actv_status: string;
  confirm_indication: {
    text: "";
    clickable: false;
  };
  kam_fam_notes: {
    text: string;
    clickable: boolean;
    type: string;
  };
  scheduled_tx_date: string;
  prescription_id: number;
  active_precert_id: number;
  pending_precert_id: number;
  appeal_precert_id: number;
  rx_pa_prior_auth_id: number;
  review_prior_auth_id: number;
  appeal_prior_auth_id: number;
  re_run_type:string;
  message_icon:boolean;
  pcc:string;
  qns:string
  pa_workflow_required:boolean;
  practice_fax_number: number;
  practice_full_address: string;
  practice_name: string;
  practice_phone_number: number;
};
export type TodoResponseDataType = {
  coverage_available: CoverageAvailableProps;
  action_required: ActionRequiredProps;
  specialty_pharmacy: {
    sp_treatments_data: sp_treatments_data[];
    page_count: number;
    dpn_count: number;
  };
  pending: PendingDataProps;
  doctor_dropdown: { id: number; name: string; }[];
  practice_dropdown: { id: number; name: string; }[];
  section_order:string[];
};

export type SectionOrderResponseType = {
  code: number;
  message: string;
  data: string[];
};
export type TodoResponseType = {
  code: number;
  message: string;
  data: TodoResponseDataType;
};

export type TodoResponseError = {
  code: number;
  error: string;
};

export type CommonProps = {
  currentPage: number;
  onActionPerformed: () => void;
  onPageChange:
    | ((action: ActionDashboardActionType) => void)
    | ((action: ActionStatisticsDashboardActionType) => void);
};

export type CoverageAvailableCompProps = CommonProps & {
  tableData: CoverageAvailableProps | undefined;

};

export type ActionRequiredCompProps = CommonProps & {
  tableData: ActionRequiredProps | undefined;

};

export type SpecialityPharmacyCompProps = CommonProps & {
  tableData:
    | {
        sp_treatments_data: sp_treatments_data[];
        page_count: number;
      }
    | undefined;
};

export type PendingCompProps = CommonProps & {
  tableData: PendingDataProps | undefined;
  
};

export type ActionDashboardState = {
  treatable_page: number;
  todo_page: number;
  sp_treatment_page: number;
  not_treated_page: number;
};
export enum ActionDashboardStateActions {
  CHANGE_TODO_PAGE = "changeTodoPage",
  CHANGE_TREATABLE_PAGE = "changeTreatablePage",
  CHANGE_SP_TREATMENT_PAGE = "changeSPTreatmentPage",
  CHANGE_NOT_TREATED_PAGE = "changeNotTreatedPage",
}
export type ActionDashboardActionType = {
  type: ActionDashboardStateActions;
  payload: number;
};
